module.exports = "\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/url-redirection/manage-url-redirection/manage-url-redirection.component.css
// module id = ./src/app/url-redirection/manage-url-redirection/manage-url-redirection.component.css
// module chunks = main